function enumize(enumDefinition) {
  const byId = {}

  const list = []

  let key

  let temp

  for (key in enumDefinition) {
    if (enumDefinition.hasOwnProperty(key)) {
      temp = Object.assign({}, enumDefinition[key])
      delete temp.id
      temp[key] = key
      list.push({
        label: enumDefinition[key].label,
        value: enumDefinition[key].id
      })
      byId[enumDefinition[key].id] = temp
    }
  }
  enumDefinition.ids = byId
  enumDefinition.list = list
  return enumDefinition
}

export const LANGUAGES = enumize({
  sk_sk: { id: 1, lang: 'sk_sk' },
  en_gb: { id: 2, lang: 'en_gb' },
  en_us: { id: 3, lang: 'en_us' },
  en_ca: { id: 4, lang: 'en_ca' }
})

export const CONFIGURATION_KEYS = enumize({
  isGOPEnabled: {
    id: 'ENABLE_GOP'
  },
  manageAllParticipants: {
    id: 'AL_PAR_BY_AU'
  },
  confirmationEmailBody: {
    id: 'PREG_CONF_EMAIL'
  },
  participantBronzeRegistrationMin: {
    id: 'PREG_B_MIN_AGE'
  },
  participantBronzeRegistrationMax: {
    id: 'PREG_B_MAX_AGE'
  },
  participantSilverRegistrationMin: {
    id: 'PREG_S_MIN_AGE'
  },
  participantSilverRegistrationMax: {
    id: 'PREG_S_MAX_AGE'
  },
  participantGoldRegistrationMin: {
    id: 'PREG_G_MIN_AGE'
  },
  participantGoldRegistrationMax: {
    id: 'PREG_G_MAX_AGE'
  },
  parentalConsent: {
    id: 'PAR_CONSENT'
  },
  refundPolicy: {
    id: 'PAY_REF_POL'
  },
  securityPolicy: {
    id: 'PAY_SEC_POL'
  },
  termsAndConditions: {
    id: 'T_CONDITIONS'
  },
  termsAndConditionsLeader: {
    id: 'T_CONDITIONS_AL'
  },
  termsAndConditionsAssessor: {
    id: 'T_CONDITIONS_AS'
  },
  termsAndConditionsUnit: {
    id: 'T_CONDITIONS_AU'
  },
  userGuideParticipant: {
    id: 'U_GUIDE_PART'
  },
  userGuideLeader: {
    id: 'U_GUIDE_AL'
  },
  userGuideWebLeader: {
    id: 'UWEB_GUIDE_AL'
  },
  userGuideWebNao: {
    id: 'UWEB_GUIDE_NAO'
  },
  userGuideWebParticipant: {
    id: 'UWEB_GUIDE_PART'
  },
  faqDocuments: {
    id: 'FAQ_DOCUMENTS'
  },
  privacyPolicyCheck: {
    id: 'PREG_PRIV_POL'
  },
  privacyPolicyText: {
    id: 'PREG_PRIV_POL_T'
  },
  assessorHandBook: {
    id: 'ASS_REF_AW_BOOK'
  },
  assessorOnlineModules: {
    id: 'ASS_REF_ONL_MOD'
  },
  leaderMinAge: {
    id: 'AL_REG_MIN_AGE'
  },
  payFees: {
    id: 'PAY_FEES'
  },
  assessorCodeOfConduct: {
    id: 'ASS_CO_CONDUCT'
  },
  assessorRoleResponsibility: {
    id: 'ASS_ROLE'
  },
  assessorRequirements: {
    id: 'ASS_KEY_CON_REQ'
  },
  volunteerCodeOfConduct: {
    id: 'VOL_CO_CONDUCT'
  },
  marketingMaterialsFromNao: {
    id: 'AL_MRKT_MAT_NAO'
  },
  marketingMaterialsFromOa: {
    id: 'AL_MRKT_MAT_OA'
  },
  marketingMaterialsFromIaf: {
    id: 'AL_MRKT_MAT_IAF'
  },
  payCheckoutUrl: {
    id: 'PAY_CHECK_URL'
  },
  aboutAwardUrl: {
    id: 'ABOUT_AWARD_URL'
  },
  directPayDesc: {
    id: 'PREG_D_PAY_DESC'
  },
  onlinePayDesc: {
    id: 'PREG_O_PAY_DESC'
  },
  payPalPayDesc: {
    id: 'PREG_PPAL_DESC'
  },
  onlineManualPayDesc: {
    id: 'PREG_OMPAY_DESC'
  },
  exemptPayDesc: {
    id: 'PREG_E_PAY_DESC'
  },
  auCoConduct: {
    id: 'AU_CO_CONDUCT'
  },
  auCoConductDoc: {
    id: 'AU_CO_CON_DOC'
  },
  enableNaoRegRequirements: {
    id: 'ENABLE_NAO_REGQ'
  },
  isAssessorManagementEnabled: {
    id: 'MANAG_ASSESSOR'
  },
  naoRegRequirementsUrl: {
    id: 'NAO_REGQ_URL'
  },
  enablePrivacyPolicyAgreement: {
    id: 'ENABLE_PP'
  },
  privacyPolicyUrl: {
    id: 'PP_URL'
  },
  participantAge: {
    id: 'PREG_PC_FR_AGE'
  },
  enableOperatingAuthority: {
    id: 'ENABLE_OA_SOA'
  },
  participantRegistrationParentalConsentElectronically: {
    id: 'PREG_PAR_CO_EL'
  },
  participantRegistrationParentalConsentNotRequired: {
    id: 'PREG_PAR_CO_NR'
  },
  participantRegistrationParentalConsentPaper: {
    id: 'PREG_PAR_CO_P'
  },
  participantRegistrationSkipPayment: {
    id: 'PREG_SKIP_PAY'
  },
  participantRegistrationSkipPaymentSilver: {
    id: 'PREG_SKIP_PAY_S'
  },
  participantRegistrationSkipPaymentGold: {
    id: 'PREG_SKIP_PAY_G'
  },
  postalAddress: {
    id: 'POST_ADDR'
  },
  participantRegistrationAwardLeader: {
    id: 'P_REG_AL'
  },
  participantRegistrationEmailAddress2: {
    id: 'P_REG_AD2'
  },
  participantRegistrationPhoneType: {
    id: 'P_REG_PH_T'
  },
  participantRegistrationSecondaryPhone: {
    id: 'P_REG_SEC_P'
  },
  participantRegistrationSecPhoneType: {
    id: 'P_REG_S_PH_T'
  },
  participantRegistrationTitle: {
    id: 'P_REG_TITLE'
  },
  participantRegistrationMiddleName: {
    id: 'P_REG_M_NAME'
  },
  participantRegistrationNationality: {
    id: 'P_REG_NAT'
  },
  participantRegistrationEmplStatus: {
    id: 'P_REG_E_STAT'
  },
  participantRegistrationAddressLine2: {
    id: 'P_REG_ADD2'
  },
  participantRegistrationAddressLine1: {
    id: 'P_REG_ADD1'
  },
  participantRegistrationPhoneNumber: {
    id: 'P_REG_PH'
  },
  participantRegistrationAddressCity: {
    id: 'P_REG_CITY'
  },
  participantRegistrationAddressZipCode: {
    id: 'P_REG_PCODE'
  },
  participantRegistrationAddressRegion: {
    id: 'P_REG_REGION'
  },
  participantRegistrationAddressCountry: {
    id: 'P_REG_COUNTRY'
  },
  organizationContactEmailAddress2: {
    id: 'OC_REG_AD2'
  },
  organizationContactPhoneNumber: {
    id: 'OC_REG_PH'
  },
  organizationContactMiddleName: {
    id: 'OC_REG_M_NAME'
  },
  organizationContactGender: {
    id: 'OC_REG_GENDER'
  },
  organizationContactTitle: {
    id: 'OC_REG_TITLE'
  },
  organizationContactDateOfBirth: {
    id: 'ENABLE_SHOW_DOB'
  },
  organizationContactAddressLine1: {
    id: 'OC_REG_ADD1'
  },
  organizationContactAddressLine2: {
    id: 'OC_REG_ADD2'
  },
  organizationContactAddressCity: {
    id: 'OC_REG_CITY'
  },
  organizationContactAddressZipCode: {
    id: 'OC_REG_PCODE'
  },
  organizationContactAddressRegion: {
    id: 'OC_REG_REGION'
  },
  organizationContactAddressCountry: {
    id: 'OC_REG_COUNTRY'
  },
  organizationContactRole: {
    id: 'OC_REG_ROLE'
  },
  definitionRegistrationLocation: {
    id: 'DEF_REG_LOC_ID'
  },
  assessorMandatory: {
    id: 'ENABLE_ASS_MD'
  },
  assessorWelcomeEmail: {
    id: 'ENABLE_ASS_WM'
  },
  gpServiceUrl: {
    id: 'GP_SERVICE_URL'
  },
  enablePaymentRefundPolicy: {
    id: 'ENABLE_PAY_REFP'
  },
  isBadgesEnabled: {
    id: 'ENABLE_BADGES',
  },
  isBadgesStrictModeEnabled: {
    id: 'ENABLE_STRICT_BADGES',
    valueType: 'BOOLEAN'
  },
  authContactAsMainCoordinatorIsEnabled: {
    id: 'ENABLE_SAME_CONTACT'
  },
  authContactIsEnabled: {
    id: 'ENABLE_AC_AU_REG'
  },
  participantRegProfileQuestionDesc: {
    id: 'PART_REG_PQ_DESC'
  },
  isPersonalReflectionMandatory: {
    id: 'ENABLE_PER_REF_MANDATORY'
  },
  isPersonalReflectionFroActivityEnabled: {
    id: 'ENABLE_PER_REF_ACT'
  },
  isAssessorReportAdditionalInfoEnabled: {
    id: 'ENABLE_ASS_EXTENSION',
    valueType: 'BOOLEAN'
  },
  isBulkLogsEnabled: {
    id: 'ENABLE_LOGS_BULK',
    valueType: 'BOOLEAN'
  },
  isBulkLogsForBronzeEnabled: {
    id: 'ENABLE_LOGS_BULK_BRONZE',
    valueType: 'BOOLEAN'
  },
  isBulkLogsForSilverEnabled: {
    id: 'ENABLE_LOGS_BULK_SILVER',
    valueType: 'BOOLEAN'
  },
  isBulkLogsForGoldEnabled: {
    id: 'ENABLE_LOGS_BULK_GOLD',
    valueType: 'BOOLEAN'
  },
  passwordSpecChars: {
  id: 'PSW_SPEC_CHARS'
  },
  awardBronzeMedalImage: {
    id: 'AWARD_BADGE_B'
  },
  awardSilverMedalImage: {
    id: 'AWARD_BADGE_S'
  },
  awardGoldMedalImage: {
    id: 'AWARD_BADGE_G'
  },
  isSimplifiedAssessmentAllowed: {
    id: 'ALLOW_SIMPLIFIED_ASSESSMENT'
  }
})

export const ROLES = enumize({
  PARTICIPANT: { id: 1, u: 'participant', role: 'PARTICIPANT' },
  LEADER: { id: 2, u: 'leader', role: 'AWARD_LEADER' },
  NAO_STAFF: { id: 3, u: 'naa_oa_staff', role: 'NAA_OA_STAFF' },
  IF_STAFF_SUPER: {
    id: 4,
    u: 'if_staff_superuser',
    roles: 'IF_STAFF_SUPERUSER'
  },
  IF_STAFF_USER: {
    id: 4,
    u: 'if_staff_stat_user',
    role: 'IF_STAFF_STATISTICAL_USER'
  },
  IF_STAFF_VIEWER: { id: 5, u: 'if_staff_viewer', role: 'IF_STAFF_VIEWER' },
  AWARD_VERIFIER: { id: 6, u: 'award_verifier', role: 'AWARD_VERIFIER' },
  COORDINATOR: { id: 7, u: 'coordinator', role: 'COORDINATOR' },
  AJ_ASSESSOR: { id: 7, u: 'aj_assessor', role: 'AJ_ASSESSOR' },
  AJ_SUPERVISOR: { id: 8, u: 'aj_supervisor', role: 'AJ_SUPERVISOR' },
  AJ_INSTRUCTOR: { id: 9, u: 'aj_instructor', role: 'AJ_INSTRUCTOR' },
  ALL: { id: 0, u: 'all' },
  ASSESSOR: { id: 10, u: 'assessor', role: 'ASSESSOR' }
})

export const ACTION_DISCRIMINATORS = enumize({
  awardLeaderSignoffRequest: { code: 'AW_AL_SIGN_RQ' },
  activityAssessmentRequestAction: { code: 'ACT_ASSESSMENT_REQ' },
  activityAssessmentAction: { code: 'ACT_ASSESSMENT' }
})



export const CLIENT_IDS = enumize({
  fo: { id: 'frontoffice-web' },
  bo: { id: 'backoffice-web' }
})

export const LEVELS = enumize({
  BRONZE: { id: 'BRONZE', label: 'Bronze' },
  SILVER: { id: 'SILVER', label: 'Silver' },
  GOLD: { id: 'GOLD', label: 'Gold' }
})

export const AJ_TYPES = enumize({
  EXPLORATION: { id: 87 },
  EXPEDITION: { id: 84 }
})

export const TITLES = enumize({
  MRS: { id: 1, label: 'Mrs' },
  MR: { id: 2, label: 'Mr' }
})

export const IMAGE_SIZES = enumize({
  default: { size: 'r=500x500' },
  dropdown: { size: 'r=30x30' }
})

export const GENDERS = enumize({
  MRS: { id: 1, label: 'Male' },
  MR: { id: 2, label: 'Female' }
})

export const PHONE_TYPES = enumize({
  MRS: { id: 'MOBILE', label: 'Mobile' },
  MR: { id: 'WORK', label: 'Work' }
})

export const EMPLOYEMENT_STATUSES = enumize({
  MRS: { id: 1, label: 'Normal' },
  MR: { id: 2, label: 'Test' }
})

export const NATIONALITIES = enumize({
  MRS: { id: 1, label: 'CZ' },
  MR: { id: 2, label: 'SK' }
})

export const DELIVERY_TYPES = enumize({
  ELECTRONICALLY: { value: 'ELECTRONICALLY' },
  PAPER: { value: 'PAPER' },
  NOT_REQUIRED: { value: 'NOT_REQUIRED' }
})

export const CODE_LISTS = enumize({
  GENDERS: { id: 'CL_GENDERS', label: 'genders' },
  AWARD_LEVELS: { id: 'CL_AWARD_LEVELS', label: 'awardLevels' },
  EMPLOYMENT_STATUSES: {
    id: 'CL_EMPLOYMENT_STATUSES',
    label: 'employmentStatuses'
  },
  NATIONALITIES: { id: 'CL_NATIONALITIES', label: 'nationalities' },
  TITLES: { id: 'CL_TITLES', label: 'titles' },
  PHONE_TYPES: { id: 'CL_PHONE_TYPES', label: 'phoneTypes' },
  CONSENT_DELIVERY_TYPES: {
    id: 'CL_CONSENT_DELIVERY_TYPES',
    label: 'consentDeliveryTypes'
  },
  USER_REGISTRATION_ASSESSMENT_STATES: {
    id: 'CL_USER_REGISTRATION_ASSESSMENT_STATES',
    label: 'userRegistrationAssessmentStates'
  },
  AJ_CATEGORIES_TYPES: {
    id: 'CL_AJ_EVENT_CATEGORIES',
    label: 'ajEventCategories'
  },
  MODE_OF_TRANSPORT_TYPES: {
    id: 'CL_MODE_OF_TRANSPORT_TYPES',
    label: 'modeOfTransportTypeList'
  },
  ORGANIZATION_TYPES: {
    id: 'CL_ORGANIZATION_TYPES',
    label: 'organizationTypes'
  },
  PROJECT_LOCATION_TYPES: {
    id: 'CL_PROJECT_LOCATION_TYPES',
    label: 'projectLocationTypes'
  },
  ONLINE_PAYMENT_TYPES: {
    id: 'CL_ONLINE_PAYMENT_TYPES',
    label: 'onlinePaymentTypes'
  },
  EXEMPTION_WWC_REASON_TYPES: {
    id: 'CL_ASS_EXEMPTION_WWC_REASON_TYPES',
    label: 'assessorExemptionWWCReasonsTypes'
  }
})

export const HIERARCHY_LEVELS = enumize({
  IAC: { id: 'IAC' },
  AU: { id: 'AU' }
})

export const PROGRESS_STATES = enumize({
  running: { id: 'award_state.running' },
  setup: { id: 'award_state.setup' },
  ajActive: { id: 'aje_status.active' },
  alApproved: { id: 'award_leader_approvement_state.approved' },
  participantApproved: { id: 'user_registration_assessment_state.approved' }
})

export const BADGE_LEVELS = enumize({
  apprentice: { id: 'APPRENTICE' },
  hero: { id: 'HERO' },
  master: { id: 'MASTER' }
})

export const ACTIVITY_STATES = enumize({
  setup: { id: 'SETUP', label: 'Not started' },
  waiting_for_approval: { id: 'APPROVAL', label: 'Waiting for approval' },
  in_progress: { id: 'IN_PROGRESS', label: 'In progress' },
  assessment: { id: 'ASSESSMENT', label: 'Waiting for assessment' },
  award_leader_singoff: { id: 'LEADER_SIGNOFF', label: 'Waiting for sign-off' },
  office_signoff: { id: 'OFFICE_SIGNOFF', label: 'Awaiting Office Sign-off' },
  complete: { id: 'COMPLETE', label: 'Completed' },
  replaced: { id: 'REPLACED', label: 'Completed' },
  ceremony: { id: 'CEREMONY', label: 'Completed' },
  deleted: { id: 'DELETED', label: 'Deleted' }
})

export const RP_STATES = enumize({
  in_progress: { id: 'IN_PROGRESS', label: 'In progress' }
})

export const AWARD_STATES = enumize({
  setup: { id: 'SETUP', label: 'Started' },
  in_progress: { id: 'IN_PROGRESS', label: 'In Progress' },
  leader_signoff: {
    id: 'LEADER_SIGNOFF',
    label: 'Awaiting Award Leader approval'
  },
  office_signoff: {
    id: 'OFFICE_SIGNOFF',
    label: 'Awaiting Organization Approval'
  },
  ceremony: { id: 'CEREMONY', label: 'Award complete' },
  inactive: { id: 'INACTIVE', label: 'Inactive' },
  reg_assignment: { id: 'REG_ASSIGNMENT', label: 'Registration assignment' },
  reg_approval: { id: 'REG_APPROVAL', label: 'Registration approval' },
  reg_not_approved: {
    id: 'REG_NOT_APPROVED',
    label: 'Registration not approved'
  },
  complete: { id: 'COMPLETE', label: 'Level Complete' }
})

export const ACTIVITY_SECTIONS = enumize({
  skill: { id: 'SKILL', label: 'Skills' },
  service: { id: 'SERVICE', label: 'Service' },
  physical_recreation: {
    id: 'PHYSICAL_RECREATION',
    label: 'Physical Recreation'
  },
  adventurous_journey: {
    id: 'ADVENTUROUS_JOURNEY',
    label: 'Adventurous Journey'
  },
  residential_project: {
    id: 'RESIDENTIAL_PROJECT',
    label: 'Residential Project'
  }
})

export const AJ_EVENT_CATEGORIES = enumize({
  trainingAndPrep: {
    id: 'PREPARATION_AND_TRAINING',
    index: 0,
    url: 'preparation-and-training',
    label: 'Preparation and Training'
  },
  practice: { id: 'PRACTICE', index: 1, url: 'practice', label: 'Practice' },
  qualification: {
    id: 'QUALIFICATION',
    index: 2,
    url: 'qualification',
    label: 'Qualification'
  }
})

export const PAYMENT_TYPES = enumize({
  onlineManual: { id: 'ONLINE_MAN_TRANS', label: 'Online' },
  online: { id: 'ONLINE_MASTERCARD', label: 'Online' },
  payPal: { id: 'ONLINE_PAYPAL', label: 'Paypal' },
  globalPayments: { id: 'ONLINE_GP', label: 'Online' },
  globalPaymentsWebpay: { id: 'ONLINE_GP_WP', label: 'Online' },
  offline: { id: 'OFFLINE', label: 'Offline' },
  exempt: { id: 'EXEMPT', label: 'Exempt' },
  directTransfer: { id: 'DIRECT_TRANSFER', label: 'Direct transfer' },
  wholesale: { id: 'WHOLESALE', label: 'Wholesale' }
})

export const PAYMENT_STATES = enumize({
  paid: { id: 'PAID', label: 'Paid' },
  notPaid: { id: 'NOT_PAID', label: 'Not Paid' }
})

export const ONLINE_PAYMENT_TYPES = enumize({
  masterCard: { id: 'MASTERCARD', label: 'MasterCard' },
  payPal: { id: 'ONLINE_PAYPAL', label: 'PayPal' },
  globalPayments: { id: 'ONLINE_GP', label: 'GlobalPayments' },
  globalPaymentsWebPay: { id: 'ONLINE_GP_WP', label: 'GlobalPayments Webpay' }
})

export const AWARD_LEVELS = enumize({
  bronze: { id: 'BRONZE', label: 'Bronze Level' },
  silver: { id: 'SILVER', label: 'Silver Level' },
  gold: { id: 'GOLD', label: 'Gold Level' }
})
/* eslint-enable */

export const CURRENCIES = enumize({
  GBP: { id: 'GBP', label: '£' }
})

export const SUPPORTED_FILE_TYPES = [
  'image/jpeg',
  'image/png',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/pdf'
  // 'video/mp4'
]

export const AGE = {
  adult: 18
}

export const LOCAL_STORAGE = {
  isAwardStaff: 'isAwardStaff'
}

export const SUPPORTED_IMG_TYPES = ['image/jpeg', 'image/png']

export const HEADER_COLORS = {
  blue: { id: 'BLUE' },
  green: { id: 'GREEN' },
  orange: { id: 'ORANGE' }
}

export const AJ_MIN_DATES = enumize({
  bronze: { days: 2, nights: 1 },
  silver: { days: 3, nights: 2 },
  gold: { days: 4, nights: 3 }
})

export const PARENTAL_FIELDS = [
  'parentFirstName',
  'parentLastName',
  'parentPhone',
  'parentRelationship',
  'parentEmail',
  'parentEmailCheck',
  'consentDeliveryType'
]

export const TOKEN_STATES = {
  revoked: { id: 'TOKEN_REVOKED' },
  expired: { id: 'TOKEN_EXP' },
  unauthorized: { id: 'UNAUTHORIZED' }
}

export const HTTP_STATUS_CODES = {
  SERVICE_UNAVAILABLE: 503
}

export const AWARD_FILE_CATEGORY_TYPES = enumize({
  activity: { id: 'ACTIVITY' },
  adventureJourney: { id: 'ADVENTURE_JOURNEY' },
  residentialProject: { id: 'RESIDENTIAL_PROJECT' },
  other: { id: 'OTHER' },
  parentalConsent: { id: 'PARENTAL_CONSENT' }
})

export const ASSESSOR_REG_STATE_TYPES = enumize({
  approval: { id: 'APPROVAL' },
  registered: { id: 'REGISTERED' },
  wwcExpired: { id: 'REG_CHILD_P_EXPIRED' },
  pending: { id: 'REG_PENDING' }
})


export const ASSESSOR_ACT_REG_STATE_TYPES = enumize({
  created: { id: 'CREATED' },
  pending: { id: 'PENDING' },
  approval: { id: 'APPROVAL' },
  revised: { id: 'REVISED' },
  completed: { id: 'COMPLETED' }
})

export const ASSESSOR_WWC_STATE_TYPES = enumize({
  pending: { id: 'PENDING' },
  approved: { id: 'APPROVED' },
  revised: { id: 'REVISED' },
  exempted: { id: 'EXEMPTED' },
  expired: { id: 'EXPIRED' }
})

export const AWARD_TYPES = enumize({
  regular: { id: 'REGULAR' },
  simplified: { id: 'SIMPLIFIED' }
})

export const ACCOUNT_TYPES = enumize({
  participant: { id: 'PARTICIPANT' },
  organizationStaff: { id: 'ORGANIZATION_CONTACT' }
})